import IconButton from "@/components/IconButton";
import { PhotoboothPerson } from "../queries";
import { PreviewContent } from "@/features/photobooth";
import type { PhotoboothCaptureMethod } from "../_utils/amplitude";

interface PreviewPageProps {
  person: PhotoboothPerson;
  imageData: string;
  captureMethod: PhotoboothCaptureMethod;
  onRetake: () => void;
  onClose: () => void;
  onSaveComplete: () => void;
}

export default function PreviewPage({
  person,
  imageData,
  captureMethod,
  onRetake,
  onClose,
  onSaveComplete
}: PreviewPageProps) {
  return (
    <div className="fixed inset-0 bg-sys-brand-surface z-50 flex flex-col" data-testid="preview-page">
      <div className="flex items-center justify-between p-4 border-b border-sys-brand-outline-variant bg-sys-brand-surface">
        <IconButton name="arrow_back" onClick={onRetake} title="Retake" />
        <div className="text-center">
          <h1 className="text-title-medium-bold font-serif text-sys-brand-on-surface">
            {person.firstName} {person.lastName}
          </h1>
          <p className="text-label-small text-sys-brand-primary">Headshot Preview</p>
        </div>
        <IconButton name="close" onClick={onClose} title="Close" />
      </div>

      <div className="flex-1 overflow-auto p-4 flex items-center justify-center">
        <div className="w-full max-w-lg">
          <PreviewContent
            person={person}
            imageData={imageData}
            onRetake={onRetake}
            onSaveComplete={onSaveComplete}
            analyticsSource="photobooth_page"
            captureMethod={captureMethod}
          />
        </div>
      </div>
    </div>
  );
}
